import { Descriptions, Modal, Spin } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import OtpModal from "./OtpModal";

function VerificationModal({ open, handleCancel, handleFetchData,setopenVerification }) {
  const { singlePaymentObj } = useSelector((state) => state.folder);
  const { saving } = useSelector((state) => state.save);

  const [openOtp, setopenOtp] = useState(false);
  async function handleCancelOtp() {
    await setopenOtp(false);
    await setopenVerification(true);
  }

  async function handleOpenOtp() {
    await setopenOtp(true)
    await setopenVerification(false);
  }

   

  const onFinish = async (data) => { 
    handleOpenOtp()
    // const res = await dispatch(
    //   save({
    //     ...data,
    //     url: "hr/saveLeaveDay.action",
    //   })
    // );
    // if (res?.payload?.success) {
    //   await toast.success(res?.payload?.messages?.message);
    //   await handleFetchData();
    //   await setFormData({});
    //   await handleCancel();
    //   await form.resetFields();
    // } else {
    //   toast.error(res?.payload?.messages?.message);
    // }
  };

  const itemsBank = [
    {
      key: "1",
      label: "Payment Method",
      children: singlePaymentObj?.paymentMethod,
    },
    {
      key: "2",
      label: "Payment Source",
      children: singlePaymentObj?.sgId,
    },
  ];

  const itemsMobile = [
    {
      key: "1",
      label: "Payment Method",
      children: singlePaymentObj?.paymentMethod,
    },
    {
      key: "2",
      label: "Payment Source",
      children: singlePaymentObj?.sgId,
    },
  ];

  return (
    <>
    <Modal
      className="modal-btn mod-height mod-footer"
      title={`Verification`}
      open={open}
      onOk={onFinish}
      onCancel={handleCancel}
      width={850}
      maskClosable={false}
    >
      <p className="text-[15px] text-[#000] font-[600] mb-8 font-dmSans">
        Would you like to make the following transfer?
      </p>

      <div className="mt-[1.25rem]">
        {singlePaymentObj?.paymentMethod === "Bank" ? (
          <Descriptions
            column={1}
            colon={false}
            title="Single Payment Information"
            items={itemsBank}
          />
        ) : (
          <Descriptions
            column={1}
            colon={false}
            title="Single Payment Information"
            items={itemsMobile}
          />
        )}
      </div>

      <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
        <div className="justify-start"></div>
        <div className="justify-end flex items-center gap-x-2">
          <div className="w-[150px]">
            <button
              key="back"
              type="button"
              onClick={handleCancel}
              className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
            >
              Previous
            </button>
          </div>

          <div className="w-[150px]">
            <button
              key="submit"
              type="submit"
              className="cstm-btn"
              onClick={onFinish}
              disabled={saving}
            >
              {saving ? <Spin /> : "Next"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
    <OtpModal
        handleFetchData={handleFetchData}
        open={openOtp}
        handleCancel={handleCancelOtp}
      />
    </>
  );
}

export default VerificationModal;
